import { match } from 'ts-pattern'
import i18next from 'i18next'
import type { TargetCostOtherActualMutator } from '@/lib/entity/target_cost_other_actual'
import type { Converter } from '@/lib/converter/entityFormatter'
import { asModifiedField } from '@/lib/converter/entityFormatter'

type TargetCostOtherActualSchema = TargetCostOtherActualMutator['merged']

const formatMonth = (month: string | undefined): string => {
  if (month === undefined || month === '') return '-'
  return month.substring(0, 7) // yyyy-MM
}

export const TargetCostOtherActualConverter: Converter<TargetCostOtherActualSchema> = {
  icon: () => i18next.t('stages.icon.target_cost_other_actual'),
  title: () => i18next.t('stages.table.target_cost_other_actual'),
  subTitle: async (merged) => formatMonth(merged.month),
  modifiedFields: (modified, column) => {
    const label = i18next.t(`stages.labels.target_cost_other_actual.${column}`)

    return (
      match(column)
        .with('cost', () => asModifiedField(label, modified.cost?.toString() ?? '-'))
        .with('month', () => asModifiedField(label, formatMonth(modified.month)))
        // id, target_cost_other_id, project_id は表示しない
        .with('id', 'target_cost_other_id', 'project_id', () => undefined)
        .exhaustive()
    )
  }
}
